import { CommentRead } from "@/schemas/comments";
import { CommentItem } from "../context";

export function mapDraftCommentsToCommentRead(
  drafts: CommentItem[],
  authorName: string,
  authorRoleName?: string,
): CommentRead[] {
  return drafts.map((c) => ({
    id: c.id,
    comment: c.text,
    created_at: c.createdAt,
    author_name: authorName,
    author_role_name: authorRoleName,
  }));
}
